export default class FormResponse {
	constructor(form, responseId, captchaEnabled) {
		this.data = {
			responseId: responseId,
			formTitle: form.title,
			formId: form.id,
			fields: [],
			captchaEnabled: captchaEnabled === true,
			stripeToken: document.getElementById("stripeTokenResult") && document.getElementById("stripeTokenResult").value ? document.getElementById("stripeTokenResult").value : ""
		}

		this.needsRevision = false;

		this.addAttachmentGroup = this.addAttachmentGroup.bind(this);
		this.addField = this.addField.bind(this);
		this.addGroup = this.addGroup.bind(this);
		this.addText = this.addText.bind(this);
	}

	get asJson () {
		return this.data;
	}

	get asString () {
		return JSON.stringify(this.data);
	}

	set captchaResponseKey (key) {
		this.data.captchaResponseKey = key;
	}

	addAttachmentGroup(element, files) {
		this.data.fields.push({
			type: element.type,
			required: element.required,
			uniqueId: element.uniqueId,
			label: element.label,
			values: files
		});
	}

	addData(key, value) {
		this.data[key] = value;
	}

	// purchasedQuantity only used for payment elements with stock
	addField(element, value, purchasedQuantity) {
		var field = {
			type: element.type,
			required: element.required,
			uniqueId: element.uniqueId,
			label: element.label,
			cost: element.cost || "",
			value: value,
		};
		// Only add 'currentStock' key/value to elements with stock specified
		// used in Admin digest form response email
		if (Number.isInteger(element.stock)) {
			field.currentStock = element.stock;
		}
		if (purchasedQuantity) {
			field.purchasedQuantity = Number(purchasedQuantity);
		}

		this.data.fields.push(field);
	}

	addText(element) {
		var contentAsString = element.content;
		// strips any html from string
		var tempDiv = document.createElement('div');
		tempDiv.innerHTML = contentAsString;
		var text = tempDiv.innerText;
		var field = {
			type: element.type,
			uniqueId: element.uniqueId,
			label: text,
			value: ""
		}
		this.data.fields.push(field);
	}

	addGroup(group, selections) {
		const data = {
			group: {
				required: group.required,
				label: group.label,
				type: group.type,
				uniqueId: group.uniqueId
			},
			selections: []
		};
		if (group.type == "TABLE_GROUP") {
			data.group.tableLabel = group.tableLabel;
		}

		// Any property that doesn't exist doesn't get sent to confirm page
		if (selections.length) {
			selections.forEach(selection => {
				data.selections.push({
					uniqueId: selection.uniqueId || selection.id,
					cost: selection.cost,
					title: selection.title,
					value: selection.label,
					custom: selection.hasOwnProperty('custom')
				})
			});
		}

		this.data.fields.push(data);
	}

	updateEditInfo(ip, userId) {
		this.data.lastUpdated = {
			ip,
			userId
		};
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/classes/form-response.js